@if (workspace) {
  <pp-settings-container>
    <pp-settings-header>
      <header class="settingsSite__header">
        @if (fromAccount) {
          <div class="previousPageBtnContainer">
            <a class="backToSite linkButton" (click)="goToPreviousPage()">
              <pp-icon class="backArrow" [ppSrc]="EIconPath.ARROW_BACK"></pp-icon>
              {{ 'back_to_account_settings' | ppTranslate }}</a
            >
          </div>
        }
        <h4 class="settingsSite__acc-name">
          {{ workspace.accountName }}
        </h4>
        <h1 class="settingsSite__siteName">
          {{ workspace.siteName }}
        </h1>
        @if (
          workspace.share.shareOption === EUserRole.SITE_ADMIN ||
          workspace.share.shareOption === EUserRole.OWNER ||
          workspace.share.shareOption === EUserRole.ACCOUNT_ADMIN
        ) {
          <ul class="settingsSite__tabs">
            @if (importExcelPointsFlagEnabled && workspace.share.shareOption === EUserRole.OWNER) {
              <li class="settingsSite__tab" routerLinkActive="settingsSite__tab--active">
                <a
                  data-m-target="Site settings import points button"
                  class="settingsSite__tab-link"
                  [routerLink]="['/settings/site/', workspaceId, ESiteSettingsPaths.IMPORT_POINTS]"
                >
                  {{ 'site_settings_tabs_import_points' | ppTranslate }}
                </a>
              </li>
            }
            <li class="settingsSite__tab" routerLinkActive="settingsSite__tab--active">
              <a
                data-m-target="Site settings tags button"
                class="settingsSite__tab-link"
                [routerLink]="['/settings/site/', workspaceId, ESiteSettingsPaths.TAGS]"
              >
                {{ 'tags' | ppTranslate }}
              </a>
            </li>
            <li class="settingsSite__tab" routerLinkActive="settingsSite__tab--active">
              <a
                data-m-target="Site settings custom fields button"
                class="settingsSite__tab-link"
                [routerLink]="['/settings/site/', workspaceId, ESiteSettingsPaths.CUSTOM_FIELDS]"
              >
                {{ 'custom_fields' | ppTranslate }}
              </a>
            </li>
            <li class="settingsSite__tab" routerLinkActive="settingsSite__tab--active">
              <a
                data-m-target="Site settings users button"
                class="settingsSite__tab-link"
                [routerLink]="['/settings/site/', workspaceId, ESiteSettingsPaths.USERS]"
              >
                {{ 'users' | ppTranslate }}
              </a>
            </li>
            @if (workspace.share.shareOption === EUserRole.OWNER) {
              <li class="settingsSite__tab" routerLinkActive="settingsSite__tab--active">
                <a
                  data-m-target="Site settings site plan button"
                  class="settingsSite__tab-link"
                  [routerLink]="['/settings/site/', workspaceId, ESiteSettingsPaths.PLAN]"
                >
                  {{ 'site_plan' | ppTranslate }}
                </a>
              </li>

              <li class="settingsSite__tab" routerLinkActive="settingsSite__tab--active">
                <a
                  data-m-target="Site settings site plan button"
                  class="settingsSite__tab-link"
                  [routerLink]="['/settings/site/', workspaceId, ESiteSettingsPaths.LOGO]"
                >
                  {{ 'pdf_logo_header' | ppTranslate }}
                </a>
              </li>
            }
            @if (integrationsEnabled) {
              <li class="settingsSite__tab" routerLinkActive="settingsSite__tab--active">
                <a
                  data-m-target="Site settings integrations button"
                  class="settingsSite__tab-link"
                  [routerLink]="['/settings/site/', workspaceId, ESiteSettingsPaths.INTEGRATIONS]"
                >
                  {{ 'integrations' | ppTranslate }}
                </a>
              </li>
            }
          </ul>
        }
      </header>
    </pp-settings-header>
    @if (
      workspace.share.shareOption === EUserRole.SITE_ADMIN ||
      workspace.share.shareOption === EUserRole.OWNER ||
      workspace.share.shareOption === EUserRole.ACCOUNT_ADMIN
    ) {
      <router-outlet></router-outlet>
    }
  </pp-settings-container>
}
